



































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { changeLoading } from '@/util/plugins';
import XLSX from 'xlsx';
const { VUE_APP_CSRF: CSRF } = process.env;
const dateFormat = require('bmh/date-format');
import moment, { Moment } from 'moment';
import { USER_DATA_LIST, UserTypeEnum} from './constant';
const { VUE_APP_FCAPI: FCAPI } = process.env;
const API = {
  user_list: `${FCAPI}/shang/ruan/user`, // 用户列表
  list: `${FCAPI}/shang/ruan/setting/butler`, // 管家列表
  export: `${FCAPI}/shang/ruan/user/export`, // 导出
  import: `${FCAPI}/shang/ruan/user/import`, // 导入
  modify_assistant: `${FCAPI}/shang/ruan/user/assistant/`, // 修改软装管家
  modify_user_test: `${FCAPI}/shang/ruan/user/test`, // 修改用户属性
  user_sum: `${FCAPI}/shang/ruan/user/sum`, // 获取用户数量
};
import SingleFileUpload from '@/component/single-file-upload.vue';

enum CheckBoxType {
  uncheck,
  checked,
  allchecked,
}

const _ = {
  keyBy: require('lodash/keyBy'),
};
const getUrl = require('baimahu/url-with-param');
const STATUS = [
  {
    value: 0,
    label: '全部',
  },
  {
    value: 1,
    label: '注册',
  },
  {
    value: 2,
    label: '报名',
  },
  {
    value: 3,
    label: '待定',
  },
  {
    value: 4,
    label: '已到店',
  },
  {
    value: 5,
    label: '下订',
  },
  {
    value: 6,
    label: '签约',
  },
  {
    value: 7,
    label: '无效',
  },
  {
    value: 8,
    label: '退单',
  },
];
const CUSTOMER_ESTATE = [
  {
    value: 0,
    label: '全部',
  },
  {
    value: 1,
    label: '重要',
  },
  {
    value: 2,
    label: '一般',
  },
];
function initTableData(remote?: any) {
  remote = remote || {};
  return {
    current: remote.current || 0,
    detail: remote.detail || [],
    last: remote.last || 0,
    limit: remote.limit || 0,
    total: remote.total || 0,
  };
}
function initFilterValue() {
  return {
    city: '',
    status: 0,
    name_or_mobile: '',
    latest_community: '',
    tag: 0,
    create_time: null,
    callback_time: null,
    assistant_id: 0,
    current: 1,
    limit: 50,
  };
}

function getSummary(): { [prop: number]: number } {
  return {
    [UserTypeEnum.test]: 0,
    [UserTypeEnum.official]: 0,
  };
}
@Component({
  components: {
    SingleFileUpload,
  },
})
export default class UserList extends Vue {
  active_charge: any = {}; // 当前正在修改管家的用户
  is_loading: boolean = false;
  is_show_import_modal: boolean = false; // 导出模态窗
  is_show_edit_modal: boolean = false; // 编辑管家模态窗
  form_item_layout: any = {
    labelCol: { span: 3 },
    wrapperCol: { span: 19 },
  };
  input_data: any = [];
  filter_value: any = initFilterValue(); // 搜索条件数据
  modal_style: any = {
    change_charge: undefined,
  };
  user_data: any = initTableData(); // 用户列表数据
  steward_data: any = []; // 管家列表数据
  file_list: any = [];
  import_url: string = API.import;
  excel_file: any = '';
  validatorMap: any = {
    assistant_id: {
      status: '',
      help: '',
      validate: (value: string): boolean => !!value,
    },
  };
  tab_type: UserTypeEnum = UserTypeEnum.official;
  table_select_data: any = [];
  enum_checkbox_type = CheckBoxType;
  checkbox_type = CheckBoxType.uncheck;
  USER_DATA_LIST = USER_DATA_LIST;
  summary: { [prop: number]: number } = getSummary();
  UserTypeEnum = UserTypeEnum;
  // user_number = {
  //   test: 0,
  //   official: 0,
  // };
  get status() {
    return STATUS;
  }

  get statusMap() {
    return _.keyBy(STATUS, 'value');
  }

  get customerEstate() {
    return CUSTOMER_ESTATE;
  }
  get stewardMap() {
    return _.keyBy(this.steward_data, 'id');
  }

  async handleModifyUserTest() {
    if (this.table_select_data.length) {
      const res = await this.$axios.post(API.modify_user_test, {
        user_id_list: this.table_select_data,
        is_test: this.tab_type === UserTypeEnum.test ? 1 : 2,
      });
      await this.getUserList();
      this.table_select_data = [];
    }
  }

  async handleChangeTab(item: UserTypeEnum) {
    this.tab_type = item;
    this.table_select_data = [];
    await this.getUserList();
  }

  @Watch('table_select_data', {deep: true})
  watchSelectTab() {
    if (!this.table_select_data.length) {
      this.checkbox_type = this.enum_checkbox_type.uncheck;
      return;
    }
    this.checkbox_type = this.table_select_data.length === this.user_data.detail.length
    ? this.enum_checkbox_type.allchecked
    : this.enum_checkbox_type.checked;
  }

  handleOnChange(item: any) {
    this.table_select_data = item;
  }

  checkboxChange(item: any) {
    if (this.user_data.detail.length !== this.table_select_data.length) {
      this.table_select_data = this.user_data.detail.map((item: any) => item.id);
    } else {
      this.table_select_data = [];
    }
  }

  closeUploadModal() {
    this.is_show_import_modal = false;
    this.file_list = [];
    this.is_loading = false;
  }

  removeUpload() {
    this.file_list = [];
  }

  dateFormat(time: any, type: string = '%Y-%m-%d %H:%M:%S') {
    return dateFormat(new Date(time * 1000), type);
  }

  paginationOption(data: any) {
    return {
      current: data.current,
      total: data.total,
      pageSize: data.limit,
      showTotal: () => `共${data.total}条，每页${data.limit}条`,
    };
  }

  beforeUpload() {
    if (this.file_list.length > 0) {
      this.$message.error('最多上传一个文件，请先删除当前文件或者将文件整合在一个excel中');
      return false;
    }
  }

  // 清空搜索条件
  clearForm() {
    this.filter_value = initFilterValue();
  }

  editAssistant(item: any) {
    this.is_show_edit_modal = true;
    this.active_charge = item;
    this.modal_style.change_charge = item.assistant_id || undefined;
  }

  handleFileChange(info: any) {
    this.is_loading = true;
    if (info.fileList.length !== 0) {
      this.file_list = [info.fileList[0]];
      this.file_list[0].status = 'done';
    }
  }

  closeUpdateMolda() {
    this.is_show_edit_modal = false;
    this.validatorMap.assistant_id.status = '';
    this.validatorMap.assistant_id.help = '';
  }

  @changeLoading(['is_loading'])
  async updateAssistant() {
    if (!this.modal_style.change_charge) {
      this.validatorMap.assistant_id.status = 'error';
      this.validatorMap.assistant_id.help = '请选择软装管家';
      return;
    } else {
      this.validatorMap.assistant_id.status = '';
      this.validatorMap.assistant_id.help = '';
    }
    const res = await this.$axios.put(`${API.modify_assistant}${this.active_charge.id}`, {
      assistant_id: this.modal_style.change_charge,
      assistant_name: this.steward_data.filter((item: any) => item.id === this.modal_style.change_charge)[0]
        .charge,
    });
    if (res.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    this.$message.success('编辑软装管家成功');
    this.closeUpdateMolda();
    await this.getUserList();
  }

  async uploadFile(file: any) {
    const data = new FormData();
    data.append('file', file.file);
    this.excel_file = data;
  }

  @changeLoading(['is_loading'])
  async doneUpload() {
    if (!this.file_list.length) {
      this.$message.error('请选择上传文件');
      return;
    }
    const res = await this.$axios.post(API.import, this.excel_file);
    if (res.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    this.closeUploadModal();
    this.$message.success(
      `${res.data.data.succeed_count}条导入成功，${res.data.data.total_count - res.data.data.succeed_count}条导入失败`
    );
    await this.getUserList();
  }

  @changeLoading(['is_loading'])
  async exportData() {
    const send_data = {
      ...this.filter_value,
    };

    send_data.create_start_time = this.filter_value.create_time
      ? moment(this.filter_value.create_time[0].format('YYYY-MM-DD')).startOf('day').format('X')
      : '';
    send_data.create_end_time = this.filter_value.create_time
      ? moment(this.filter_value.create_time[1].format('YYYY-MM-DD')).endOf('day').format('X')
      : '';
    send_data.callback_start_time = this.filter_value.callback_time
      ? moment(this.filter_value.callback_time[0].format('YYYY-MM-DD')).startOf('day').format('X')
      : '';
    send_data.callback_end_time = this.filter_value.callback_time
      ? moment(this.filter_value.callback_time[1].format('YYYY-MM-DD')).endOf('day').format('X')
      : '';
    delete send_data.callback_time;
    delete send_data.create_time;
    const url = getUrl(API.export, send_data);
    const res = await this.$axios.get(url);
    if (res.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    window.location.href = url;
  }

  // 下载模版
  downloadTemplate() {
    window.location.href = 'https://shang.liuliangphone.com/xlsx/用户导入模版.xlsx';
  }

  @changeLoading(['is_loading'])
  async handleChange(data: any) {
    this.filter_value.current = data.current;
    await this.clickSearchBtn();
  }

  // 获取管家列表
  @changeLoading(['is_loading'])
  async getList(
    query_params: any = {
      page: 50,
      is_all: 1
    }
  ) {
    const url = getUrl(API.list, query_params);
    const res = await this.$axios.get(url);
    if (res.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    this.steward_data = res.data.data;
    // this.steward_data.detail.unshift({
    //   id: 0,
    //   charge: '全部',
    // });
  }

  // 点击搜索按钮
  @changeLoading(['is_loading'])
  async clickSearchBtn() {
    const send_data = {
      ...this.filter_value,
    };
    send_data.create_start_time = this.filter_value.create_time
      ? moment(this.filter_value.create_time[0].format('YYYY-MM-DD')).startOf('day').format('X')
      : '';
    send_data.create_end_time = this.filter_value.create_time
      ? moment(this.filter_value.create_time[1].format('YYYY-MM-DD')).endOf('day').format('X')
      : '';
    send_data.callback_start_time = this.filter_value.callback_time
      ? moment(this.filter_value.callback_time[0].format('YYYY-MM-DD')).startOf('day').format('X')
      : '';
    send_data.callback_end_time = this.filter_value.callback_time
      ? moment(this.filter_value.callback_time[1].format('YYYY-MM-DD')).endOf('day').format('X')
      : '';
    delete send_data.callback_time;
    delete send_data.create_time;
    await this.getUserList(send_data);
  }

  // 获取用户列表
  @changeLoading(['is_loading'])
  async getUserList(
    query_params: any = {
      current: 1,
      limit: 50,
    }
  ) {
    const url = getUrl(API.user_list, {...query_params, is_test: this.tab_type === UserTypeEnum.test ? 2 : 1});
    const res = await this.$axios.get(url);
    if (res.status !== 200) {
      this.$message.error(res.data.message);
      return;
    }
    this.user_data = initTableData(res.data.data);
    const user_sum = await this.$axios.get(API.user_sum);
    if (user_sum.status !== 200) {
      this.$message.error(user_sum.data.message);
      return;
    }
    this.summary[UserTypeEnum.official] = user_sum.data.data.official;
    this.summary[UserTypeEnum.test] = user_sum.data.data.test;
    // this.user_number = user_sum.data.data;
  }

  @changeLoading(['is_loading'])
  async created() {
    await this.getUserList();
    await this.getList();
  }
}
